
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.708 3.54A5.48 5.48 0 0122 7.44a5.49 5.49 0 01-1.54 3.86l-.01.011-2.741 2.744a5.482 5.482 0 01-8.268-.592.915.915 0 011.463-1.096 3.655 3.655 0 005.512.395l2.736-2.738a3.66 3.66 0 00-2.603-6.195 3.653 3.653 0 00-2.566 1.023L12.416 6.41a.913.913 0 11-1.289-1.297L12.7 3.55l.01-.01z","fill":"#4F71E8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.253 8.683a5.478 5.478 0 016.306 1.854.915.915 0 01-1.463 1.096 3.655 3.655 0 00-5.512-.395l-2.736 2.738a3.66 3.66 0 002.603 6.195 3.653 3.653 0 002.566-1.022l1.556-1.558a.913.913 0 111.292 1.293l-1.562 1.564-.011.011A5.48 5.48 0 012 16.56 5.49 5.49 0 013.54 12.7l.011-.011 2.741-2.744a5.483 5.483 0 011.962-1.262z","fill":"#4F71E8"}})])
          )
        }
      }
    